// Error names
export default {
  EVENT_NOT_FOUND: 'EVENT_NOT_FOUND', // When something was not found in the database
  EVENT_ACCESS_NOT_ALLOWED: 'EVENT_ACCESS_NOT_ALLOWED',
  HUBSPOT_ATTENDANCE_ERROR: 'HUBSPOT_ATTENDANCE_ERROR',
  FETCH_DISCUSSIONGROUP_FAIL: 'FETCH_DISCUSSIONGROUP_FAIL',
  FETCH_EVENTUSERS_FAIL: 'FETCH_EVENTUSERS_FAIL',
  APIGATEWAY_SUBSCRIPTION_FAILURE: 'APIGATEWAY_SUBSCRIPTION_FAILURE'
};
